import { Component, signal, OnInit } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProductService } from '../../services/product.service';
import { Product } from '../../models/product.model';

@Component({
  selector: 'app-menu',
  imports: [DecimalPipe, RouterModule],
  templateUrl: './menu.html',
  styleUrl: './menu.scss',
})
export class Menu implements OnInit {
  categories = signal<string[]>(['All']);
  activeCategory = signal('All');

  menuItems = signal<Product[]>([]);

  constructor(private productService: ProductService) {}

  ngOnInit() {
    this.productService.getProducts().subscribe({
      next: (products) => {
        // Sort products by rating descending
        const sorted = products.sort((a, b) => (b.rating || 0) - (a.rating || 0));
        this.menuItems.set(sorted);

        // Extract unique categories from the products
        const uniqueCats = new Set(sorted.map(p => p.category));
        this.categories.set(['All', ...Array.from(uniqueCats)]);
      },
      error: (err) => console.error('Failed to load menu products', err)
    });
  }

  setCategory(category: string) {
    this.activeCategory.set(category);
  }

  get filteredItems() {
    let items = this.menuItems();
    if (this.activeCategory() !== 'All') {
      items = items.filter(item => item.category === this.activeCategory());
    }
    // Limit to 6 items to keep the home page section compact
    return items.slice(0, 6);
  }

  getImgSrc(url: string | undefined): string {
    if (!url) return '';
    return url.startsWith('/uploads/') ? `https://dev.thehuskbakery.com/api${url}` : url;
  }
}
